import { useCallback, useMemo, useState } from "react";

const defaultOptions = {
  initialData: [],
  initialPage: 1,
  initialSizePerPage: 10,
  initialSortField: null,
  initialSortOrder: "asc",
};

export default function useTable(options = defaultOptions) {
  const {
    initialData,
    initialPage,
    initialSizePerPage,
    initialSortField,
    initialSortOrder,
  } = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  const [data, setData] = useState(initialData);
  const [page, setPage] = useState(initialPage);
  const [sizePerPage, setSizePerPage] = useState(initialSizePerPage);
  const [sortField, setSortField] = useState(initialSortField);
  const [sortOrder, setSortOrder] = useState(initialSortOrder);

  const handleTableChange = useCallback((type, { page, sizePerPage, sortField, sortOrder }) => {
    if (type === "pagination") {
      if (typeof page === "number") {
        setPage(page);
      }
      if (typeof sizePerPage === "number") {
        setSizePerPage(sizePerPage);
      }
    }

    if (type === "sort") {
      if (typeof sortField === "string") {
        setSortField(sortField);
      }
      if (sortOrder === "asc" || sortOrder === "desc") {
        setSortOrder(sortOrder);
      }
    }
  }, []);

  return {
    data,
    setData,
    page,
    setPage,
    sizePerPage,
    setSizePerPage,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    handleTableChange,
  };
}
